import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const RachatPropriete = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="relative pt-40 md:pt-48 pb-20 md:pb-28 bg-[#F7F4EF]" data-nav-theme="light">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
            <div className="md:col-span-6">
              <h1
                className="font-display uppercase text-neutral-900 leading-[1.05]"
                style={{ fontSize: "clamp(38px, 5.5vw, 78px)" }}
              >
                Étude & Rachat de propriété
              </h1>
              <p className="text-neutral-500 italic mt-4">
                Terrains, maisons, appartements, immeubles à céder
              </p>
              <p className="text-neutral-700 mt-7 text-[16px] leading-relaxed max-w-lg">
                Vous avez un terrain, une maison, un appartement ou un
                immeuble à céder ? Nous
                étudions chaque opportunité avec attention.
              </p>
            </div>

            <div className="md:col-span-6">
              <div className="relative aspect-[4/5] md:aspect-[5/6] w-full max-w-[560px] ml-auto overflow-hidden">
                <img
                  src="/assets/rachat-terrain.jpg"
                  alt="Étude et rachat de propriété"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <div className="w-full max-w-[560px] ml-auto mt-6">
                <button
                  onClick={() => navigate("/contact")}
                  className="inline-flex items-center gap-3 bg-neutral-900 text-white rounded-full pl-6 pr-2 py-2 text-[12px] uppercase tracking-widest font-medium hover:bg-[#9F8B76] transition-colors group active:scale-95"
                >
                  Proposer mon bien
                  <span className="w-9 h-9 rounded-full bg-[#9F8B76] flex items-center justify-center">
                    <ArrowRight className="w-4 h-4" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 md:py-28" data-nav-theme="light">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10">
          <div className="max-w-3xl space-y-5 text-[15px] md:text-[16px] leading-relaxed text-neutral-700">
            <p>
              Nous recherchons activement des terrains constructibles, des
              maisons, appartements ou immeubles à fort potentiel. Si vous
              avez un bien à céder, nous étudions votre dossier avec sérieux
              : une proposition d'achat n'est formulée qu'après étude
              approfondie de la faisabilité du projet.
            </p>
            <p>
              Notre double expertise de maître d'œuvre et d'opérateur
              immobilier nous permet d'évaluer avec précision la réalité des
              travaux et le potentiel d'un bien, pour vous faire une
              proposition juste et rapide.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default RachatPropriete;
